import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Container, Segment, Header, Button, Icon } from 'semantic-ui-react'
import { PDFViewer } from '@react-pdf/renderer'

import TaxInvoiceReport from '../components/invoice/TaxInvoiceReport'
import CommercialInvoiceReport from '../components/invoice/CommercialInvoiceReport'
import MarketInvoiceReport from '../components/invoice/MarketInvoiceReport'
import MissingInfo from '../components/invoice/shared/MissingInfo'

import Loading from '../components/common/loading'
import MainNavigation from './MainNavigation'
import TopNavigation from './TopNavigation'

// import MapViewDriverWithMarker from '../containers/drivers/mapView'
import MapView from '../containers/mapView'
import Order from '../containers/orders'
import Dashboard from '../containers/dashboard'
import Category from '../containers/category'
import Restaurants from '../containers/restaurants'
import NewRestaurant from '../containers/restaurants/new'
import EditRestaurant from '../containers/restaurants/edit'
import RestaurantDetail from '../containers/restaurants/detail'
import Deliverees from '../containers/deliverees'
import DelivereeOrders from '../containers/deliverees/delivereeOrder'
import Drivers from '../containers/drivers'
import DriverDetail from '../containers/drivers/detail'
import DriverIncentive from '../containers/driverIncentive'
import Notification from '../containers/notification'
import Partners from '../containers/partners'
import NewPartner from '../containers/partners/new'
import EditPartner from '../containers/partners/edit'
import Advertisement from '../containers/advertisement'
import NewSponsor from '../containers/advertisement/newSponsor'
import EditSponsor from '../containers/advertisement/editSponsor'
import NewPopular from '../containers/advertisement/newPopular'
import PopularDetail from '../containers/advertisement/popular'
import EditRecentList from '../containers/advertisement/editRecentList'
import NewRecentList from '../containers/advertisement/newRecentList'
import NewRecommended from '../containers/advertisement/newRecommended'
import Promotions from '../containers/promotions'
import Configurations from '../containers/configurations'
import Permissions from '../containers/permissions'
import UserManagement from '../containers/users'
import OrderGuide from '../containers/orders/guide'
import CashOuts from '../containers/cashOuts'
import CashReceivable from '../containers/cashReceivable'
import MerchantSettlement from '../containers/merchantSettlement'
import MerchantSettlementDetail from '../containers/merchantSettlement/detail'

import MerchantReport from '../containers/reports/merchant'
import SaleReport from '../containers/reports/sale'
import OperatorReport from '../containers/reports/operator'
import RefundReport from '../containers/reports/refund'
import CustomerReport from '../containers/reports/customer'
import DiscountReport from '../containers/reports/discount'
import PromotionExpenseReport from '../containers/reports/promotionExpense'
import DriverTransactionReport from '../containers/reports/driverTransaction'
import LocationReport from '../containers/reports/location'
import ExpressCODReport from '../containers/reports/expressCOD'

import DataValidation from '../containers/dataValidation'

import AppInbox from '../containers/appInbox'
import NewAppInbox from '../containers/appInbox/new'
import EditAppInbox from '../containers/appInbox/edit'
import Express from '../containers/express'
import ExpressQueueOrders from '../containers/express/queueOrders'
import Rewards from '../containers/rewards'

import SpecialDealDetail from '../components/specialDeal/dealDetail'

import AppCustomization from '../containers/appCustomization'

import MerchantCloseRequests from '../containers/merchantCloseRequests'
import ServiceAvailability from '../containers/serviceAvailability'

import RolePermissionActions from '../reducers/rolePermissionReducer'
import AuthActions from '../reducers/authReducer'
import RegionActions from '../reducers/regionReducer'
import LuckyDrawWinners from '../containers/luckyDrawWinners'

function NoMatch(props) {
  return (
    <Segment>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 160px)',
        }}
      >
        <div>
          <Header icon>
            <Icon name="warning sign" />
            404 Not found
          </Header>
        </div>
        <div>
          <Button primary onClick={() => props.history.push('/')}>
            Back to Home
          </Button>
        </div>
      </div>
    </Segment>
  )
}

class MainLayout extends Component {
  constructor() {
    super()
    let sideBarVisible = false

    if (localStorage.getItem('side-bar-visible')) {
      sideBarVisible = localStorage.getItem('side-bar-visible') === 'true'
    }

    this.state = {
      sideBarVisible,
    }

    this.notificationInitialed = false
    this.isNotificationInitialized = false
  }

  componentDidMount() {
    const { loaded, moduleLoaded, regionLoaded, getRolePermission, getModules, getRegions } = this.props

    if (!loaded) getRolePermission()
    if (!moduleLoaded) getModules()
    if (!regionLoaded) getRegions()
  }

  componentWillReceiveProps(nextProps) {
    const { roles, authData, subscribeNotification, unsubscribeNotification } = nextProps

    if (!this.isNotificationInitialized && authData.role && _.size(roles)) {
      this.isNotificationInitialized = true

      const access = (roles[authData.role] && roles[authData.role].access) || []

      if (access.includes('orders')) subscribeNotification()
      else unsubscribeNotification()
    }
  }

  onToggle = () => {
    const { sideBarVisible } = this.state

    localStorage.setItem('side-bar-visible', sideBarVisible ? 'false' : 'true')

    this.setState({ sideBarVisible: !sideBarVisible })
  }

  getRoute = module => {
    switch (module) {
      case 'dashboard':
        return <Route key={module} exact path="/dashboard" component={Dashboard} />
      case 'orders':
        return [
          <Route key={module} exact path="/orders" component={Order} />,
          <Route key={module} exact path="/orders/guide" component={OrderGuide} />,
        ]
      case 'category':
        return <Route key={module} exact path="/category" component={Category} />
      case 'restaurants':
        return [
          <Route key={module} exact path="/restaurants" component={Restaurants} />,
          <Route key={`${module}-new`} exact path="/restaurants/new" component={NewRestaurant} />,
          <Route
            key={`${module}-detail`}
            exact
            path="/restaurants/detail/:id"
            component={RestaurantDetail}
          />,
          <Route key={`${module}-edit`} exact path="/restaurants/:id/edit" component={EditRestaurant} />,
          <Route
            key="tax-invoice"
            exact
            path="/restaurants/invoice/tax"
            component={props =>
              localStorage.getItem('invoiceState') ? (
                <PDFViewer width="100%" height={1200}>
                  <TaxInvoiceReport {...props} />
                </PDFViewer>
              ) : (
                <MissingInfo {...props} />
              )
            }
          />,
          <Route
            key="commercial-invoice"
            exact
            path="/restaurants/invoice/commercial"
            component={props =>
              localStorage.getItem('invoiceState') ? (
                <PDFViewer width="100%" height={1200}>
                  <CommercialInvoiceReport {...props} />
                </PDFViewer>
              ) : (
                <MissingInfo {...props} />
              )
            }
          />,
          <Route
            key="market-invoice"
            exact
            path="/restaurants/invoice/market"
            component={props =>
              localStorage.getItem('invoiceState') ? (
                <PDFViewer width="100%" height={1200}>
                  <MarketInvoiceReport {...props} />
                </PDFViewer>
              ) : (
                <MissingInfo {...props} />
              )
            }
          />,
        ]
      case 'advertisement':
        return [
          <Route key={module} exact path="/advertisement" component={Advertisement} />,
          <Route
            key={`${module}-sponsor-new`}
            exact
            path="/advertisement/sponsor/new"
            component={NewSponsor}
          />,
          <Route
            key={`${module}-sponsor-edit`}
            exact
            path="/advertisement/sponsor/:id/edit"
            component={EditSponsor}
          />,
          <Route
            key={`${module}-recently-edit`}
            exact
            path="/advertisement/recent-restaurant-lists/new"
            component={NewRecentList}
          />,
          <Route
            key={`${module}-recently-edit`}
            exact
            path="/advertisement/recent-restaurant-lists/:id/edit"
            component={EditRecentList}
          />,
          <Route
            key={`${module}-popular-new`}
            exact
            path="/advertisement/popular/new"
            component={NewPopular}
          />,
          <Route
            key={`${module}-popular-edit`}
            exact
            path="/advertisement/popular/:id/detail"
            component={PopularDetail}
          />,
          <Route
            key={`${module}-recommended-edit`}
            exact
            path="/advertisement/recommended/edit/:id"
            component={NewRecommended}
          />,
          <Route
            key={`${module}-recommended-new`}
            exact
            path="/advertisement/recommended/new"
            component={NewRecommended}
          />,
          <Route key={`${module}-promotions`} exact path="/promotions" component={Promotions} />,
          <Route key="rewards" exact path="/rewards" component={Rewards} />,
          <Route
            key={`${module}-special-deal-detail`}
            exact
            path="/promotions/special-deal/:id"
            component={SpecialDealDetail}
          />,
        ]
      case 'app_inbox':
        return [
          <Route key={module} exact path="/app-inbox" component={AppInbox} />,
          <Route key={`${module}-new`} exact path="/app-inbox/new" component={NewAppInbox} />,
          <Route key={`${module}-edit`} exact path="/app-inbox/:id/edit" component={EditAppInbox} />,
        ]
      case 'partners':
        return [
          <Route key={module} exact path="/partners" component={Partners} />,
          <Route key={`${module}-new`} exact path="/partners/new" component={NewPartner} />,
          <Route key={`${module}-edit`} exact path="/partners/:id/edit" component={EditPartner} />,
        ]
      case 'drivers':
        return [
          <Route key={module} exact path="/drivers" component={Drivers} />,
          <Route key={`${module}-detail`} exact path="/drivers/detail/:id" component={DriverDetail} />,
          <Route key={`${module}-incentive`} exact path="/driver-segments/:id" component={DriverIncentive} />,
          <Route key={`${module}-notification`} exact path="/notification" component={Notification} />,
        ]
      case 'customers':
        return [
          <Route key={module} exact path="/customers" component={Deliverees} />,
          <Route key={`${module}-orders`} exact path="/customers/:id/order" component={DelivereeOrders} />,
        ]
      case 'users':
        return [<Route key={module} exact path="/users" component={UserManagement} />]
      case 'permissions':
        return <Route key={module} exact path="/permissions" component={Permissions} />
      case 'configurations':
        return <Route key={module} exact path="/configurations" component={Configurations} />
      case 'cashout':
        return <Route key={module} exact path="/cashouts" component={CashOuts} />
      case 'cash_receivable':
        return <Route key={module} exact path="/cash-receivable" component={CashReceivable} />
      case 'merchant_report':
        return [
          <Route key={module} exact path="/reports/merchant" component={MerchantReport} />,
          <Route key={module} exact path="/data-validation" component={DataValidation} />,
        ]
      case 'operator_report':
        return <Route key={module} exact path="/reports/operator" component={OperatorReport} />
      case 'sale_report':
        return [
          <Route key={module} exact path="/reports/sale" component={SaleReport} />,
          <Route key={`${module}-location`} exact path="/reports/location" component={LocationReport} />,
        ]
      case 'refund_report':
        return <Route key={module} exact path="/reports/refund" component={RefundReport} />
      case 'customer_report':
        return <Route key={module} exact path="/reports/customer" component={CustomerReport} />
      case 'promocode_report':
        return <Route key={module} exact path="/reports/discount" component={DiscountReport} />
      case 'promotion_expense_report':
        return (
          <Route key={module} exact path="/reports/promotion-expense" component={PromotionExpenseReport} />
        )

      case 'driver_transaction_report':
        return (
          <Route key={module} exact path="/reports/driver-transactions" component={DriverTransactionReport} />
        )
      case 'express_cod':
        return (
          <Route key={module} exact path="/reports/express-cod" component={ExpressCODReport} />
        )
      case 'merchant_settlement':
        return [
          <Route key={module} exact path="/merchant-settlements" component={MerchantSettlement} />,
          <Route
            key={module}
            exact
            path="/merchant-settlements/detail/:id"
            component={MerchantSettlementDetail}
          />,
        ]
      case 'express':
        return [
          <Route key={module} exact path="/express" component={Express} />,
          <Route key={module} exact path="/express/queue-orders" component={ExpressQueueOrders} />
        ]
      case 'app_customization':
        return <Route key={module} exact path="/app-customization" component={AppCustomization} />
      case 'merchant_close_requests':
        return <Route key={module} exact path="/close-requests" component={MerchantCloseRequests} />
      case 'service_availability':
        return <Route key={module} exact path="/service-availability" component={ServiceAvailability} />
      case 'lucky_draw_winners':
      return <Route key={module} exact path="/lucky-draw-winners" component={LuckyDrawWinners} />
      default:
        return null
    }
  }

  getRootComponent = modules => {
    switch (modules[0]) {
      case 'dashboard':
        return Dashboard
      case 'orders':
        return Order
      case 'category':
        return Category
      case 'restaurants':
        return Restaurants
      case 'items':
        return Restaurants
      case 'advertisement':
        return Advertisement
      case 'app_inbox':
        return AppInbox
      case 'partners':
        return Partners
      case 'drivers':
        return Drivers
      case 'cashReceivable':
        return CashReceivable
      case 'customers':
        return Deliverees
      case 'users':
        return UserManagement
      case 'permissions':
        return Permissions
      case 'configurations':
        return Configurations
      case 'express':
        return Express
      case 'report':
        return MerchantReport
      case 'merchant_close_requests':
        return MerchantCloseRequests
      case 'service_availability':
        return ServiceAvailability
      default:
        return null
    }
  }

  renderRoute = () => {
    const { roles, authData } = this.props
    let allRoutes = []

    if (authData.role && roles[authData.role] && roles[authData.role].access) {
      const { access } = roles[authData.role]

      allRoutes = _.map(access, module => {
        return this.getRoute(module)
      })

      return (
        <Switch>
          <Route exact path="/" component={this.getRootComponent(access)} />
          {allRoutes}
          <Route component={NoMatch} />
        </Switch>
      )
    }

    return null
  }

  render() {
    const { connection, loading } = this.props
    const { sideBarVisible } = this.state

    return (
      <Container fluid textAlign="left">
        <Loading active={loading} />
        <Router>
          <div style={{ display: 'flex', width: '100%' }}>
            <MainNavigation sideBarVisible={sideBarVisible} {...this.props} />
            <div
              id="main-content-locked"
              style={{
                width: '100%',
                marginLeft: sideBarVisible ? '15rem' : '0px',
                transition: 'all 0.4s',
              }}
            >
              <TopNavigation onToggle={this.onToggle} connection={connection} {...this.props} />
              {connection ? (
                <div style={{ paddingLeft: '50px', paddingRight: '50px' }}>
                  {this.renderRoute()}
                  {/* <MapViewDriverWithMarker /> */}
                  <MapView />
                </div>
              ) : (
                <div className="App no-connection">No Internet Connection</div>
              )}
            </div>
          </div>
        </Router>
      </Container>
    )
  }
}

const mapState = ({ rolePermission, auth, regions }) => ({
  roles: rolePermission.roles,
  authData: auth.data,
  loaded: rolePermission.loaded,
  loading: rolePermission.loading || rolePermission.moduleLoading || regions.loading,
  moduleLoaded: rolePermission.moduleLoaded,
  regions: regions.data,
  regionLoaded: regions.loaded,
  regionLoading: regions.loading,
})

const mapDispatch = dispatch => ({
  logout: () => dispatch(AuthActions.logout()),
  getRolePermission: () => dispatch(RolePermissionActions.getAllRoles()),
  getModules: () => dispatch(RolePermissionActions.getAllModules()),
  subscribeNotification: () => dispatch({ type: 'SUBSCRIBE_NOTIFICATION' }),
  unsubscribeNotification: () => dispatch({ type: 'UNSUBSCRIBE_NOTIFICATION' }),
  getRegions: () => dispatch(RegionActions.getRegions()),
})

export default connect(
  mapState,
  mapDispatch
)(MainLayout)



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js